import * as React from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Button, FormControl } from '@mui/material';

import Box from '@mui/material/Box';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';

import { useState, useEffect } from 'react';
import PageInfo from 'components/PageInfo';
import { getUsersByQuery } from 'components/axios/userAxios';
import queryString from 'query-string';
import { useEnumApi } from 'contexts/EnumApiContext';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import { BootstrapInput } from 'data/data';
import { useTranslation } from 'react-i18next';
import { fromServerFormat } from 'components/date_picker/dateUtils';
import useConfig from 'hooks/useConfig';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const UserSetting = () => {
  const { getEnumValueByEnumNameAndCode, getEnumValueByEnumName } = useEnumApi();
  const { t, i18n } = useTranslation();
  const { mode } = useConfig();
  const navigate = useNavigate();

  const [searchRole, setSearchRole] = useState('');
  const [searchField, setSearchField] = useState('name');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isParam, setIsParam] = useState(false);
  // const [searchFields] = useState([{code:"name", title:"이름"}, {code:"id", title:"ID"}, {code:"email", title:"이메일"}, {code:"telNo", title:"휴대폰"}]);
  const searchFields = [{code:"name", title:t('message.common.subtitle.name')}, {code:"id", title:t('login.id')}, {code:"email", title:t('message.common.subtitle.email')}];

  const qs = queryString.parse(window.location.search);
  const [searchParam, setSearchParam] = useState({});
  const [searchParamString, setSearchParamString] = useState('');
  const [sortModel, setSortModel] = useState(null);

  const roleTypes = React.useMemo(()=>{
      return getEnumValueByEnumName('RoleType');
      // .filter((role)=>(role.code !== ROLE.CS.code))
  },[getEnumValueByEnumName])

  let columns = [
    { field: 'no', headerName: 'No.', sortable: false, width: 80
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
    },
    { field: 'company.type', headerName: t('message.common.subtitle.companyType'), sortable:true, width: 120
        , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode('CompanyType', params.row?.company?.type)?.[0]?.title}</Link>)
    },
    { field: 'company.info.name', headerName: t('message.common.subtitle.company.name'), sortable:true, width: 120
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.company?.info?.name}</Link>)
    },
    { field: 'role', headerName: t('message.common.subtitle.authority'), sortable:true, width: 120
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.role && getEnumValueByEnumNameAndCode("RoleType", params.row?.role)?.[0]?.title}</Link>)
    },
    { field: 'loginId', headerName: t('login.id'), sortable:true, width: 200
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.loginId}</Link>)
    },
    { field: 'name', headerName: t('message.common.subtitle.name'), sortable:true, width: 200
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.name}</Link>)
    },
    { field: 'email', headerName: t('message.common.subtitle.email'), sortable:true,  width: 250
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.email}</Link>)
    },
    // { field: 'certificationNumber', headerName: t('message.common.subtitle.worker.certification.number'), sortable:true,  width: 250
    //   , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{params.row?.certificationNumber}</Link>)
    // },
    { field: 'createdAt', headerName: t('message.common.subtitle.createdate'), sortable:true,  width: 150
      , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{fromServerFormat(params.row?.createdAt, {format:t('message.common.text.date.format.date')})}</Link>)
    },
    { field: 'status', headerName: t('message.common.subtitle.status'), sortable:true, width: 100
        , renderCell:(params)=>(<Link to={'/setting/user/user/modify/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode('ActiveStatus', params.row?.loginActiveStatus)?.[0]?.title}</Link>)
    }
  ];
  
  const handlePaging = (value) => {
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
    setIsLoading(false);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = (value-1);
    setSearchParam(searchParamCopy);
  }

  useEffect(()=>{
    const searchOrders = searchParam.searchOrder;
    const searchParamCopy = {...searchParam};
    delete searchParamCopy.searchOrder;
    let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    if (searchOrders && searchOrders.length > 0) {
      let sortString = '';
      searchOrders.forEach(order=>sortString+="&sort="+order.sort)
      searchString += sortString;
    }
    setSearchParamString("?"+searchString)
  }, [searchParam])

  useEffect(()=>{
    const searchParamCopy = {...searchParam};
    let searchOrders = [];
    if (sortModel && sortModel.length > 0) {
      searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
    } else {
      searchOrders.push({sort : "opStatus,asc"});
    }
    searchParamCopy.searchOrder = searchOrders;
    setSearchParam(searchParamCopy)
  },[sortModel, searchParam])

  useEffect(()=> {
    if (qs) {
      if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
      if (qs.size) setPageSize(qs.size);
      if (qs.searchRole) setSearchRole(qs.searchRole);
      if (qs.searchField) setSearchField(qs.searchField);
      if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

      let searchParamCopy = {...searchParam};
      if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
      if (qs.size) {searchParamCopy.size = qs.size} ;
      if (qs.searchRole) {searchParamCopy.searchRole = qs.searchRole};
      if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
      if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
      // if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
      // if (qs.searchType) {searchParamCopy.searchType = qs.searchType};
      if (qs.sort && qs.sort.length > 0) {
        let orders = [];
        let sortModel = [];
        if (!Array.isArray(qs.sort)) {
          orders.push({sort:qs.sort});
          sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
        } else {
          (qs.sort).forEach(order=>orders.push({sort:order}));
          qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
        }
        setSortModel(sortModel)
        searchParamCopy.searchOrder = orders;
      } else {
        delete searchParamCopy.searchOrder
      };
      setSearchParam(searchParamCopy);
    }
    setIsParam(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.page, qs.size, qs.searchRole, qs.searchField, qs.searchKeyword]);

  useEffect(()=> {
    if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam) {
      usersList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, isParam, sortModel]);

  const usersList = async(curPage=currentPage) => {
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    setCurrentPage(curPage)

    let param = {
      //name : '',
      //loginId : '',
      //email : '',
      //telNo : '',
      page : curPage,
      size : pageSize
    };
    
    if (searchRole) {
      param.role = searchRole;
    }
    //let field = searchField;
    let keyword = searchKeyword;
    if (searchKeyword) {
      if (searchField && (searchField === 'name' || searchField === 'id' || searchField === 'email' || searchField === 'telNo')) {
        keyword = 'contains('+searchKeyword+')';
      }

      if (searchField === 'name') {
        param.name = keyword;
      } else if (searchField === 'id') {
        param.loginId = keyword;
      } else if (searchField === 'email') {
        param.email = keyword;
      // } else if (searchField === 'telNo') {
      //   param.telNo = keyword;
      }
    }

    if (sortModel && sortModel.length > 0)
      param.sort = sortModel[0].field+","+sortModel[0].sort;
    else
      delete param.sort;
    
// console.log(param)
    await getUsersByQuery(param).then((data)=>{
      if (data != null) {
        setPageInfo(data.page);
        //console.log(data);
        if(data._embedded) {
          let list = data._embedded.users;
          if (list) {
              list = list.map(function(user, i) {
                  return {
                      ...user,
                      idx: i + 1,
                      no: data.page.totalElements - (currentPage * data.page.size) - i
                  };
              });
          }
          setUsers(list);
        } else {
          setCurrentPage(0);
          setUsers([]);
        }
      } else {
        setPageInfo({
          size : pageInfo.size,
          totalElements : 0,
          totalPages : 0,
          number : 0
        });
        setUsers([]);
      }
      setIsLoading(true);
    });
  }
 
  // const handleSelect = (event, value) => {
  //   event.preventDefault();
  //   setSearchField(value.props.value);
  // };

  const handleInput = (event) => {
    event.preventDefault();
    setSearchKeyword(event.target.value.trim());
  };

  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    usersList(0);
    
    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};
    if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
    if (searchRole) {searchParamCopy.searchRole = searchRole};
    setSearchParam(searchParamCopy)
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  return (
    <div className="sub_container">
      <div className='search_section'>
        <div className='selectbox'>
          <div className="desktop_serach">
            <Box sx={{ minWidth: 120 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <div>
                  <div style={{display:"inline-block"}}>
                  {isLoading &&
                  <>
                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <CustomEnumSelect
                          key={searchRole}
                          label={t('message.common.subtitle.authority')}
                          labelName={t('message.common.subtitle.authority')}
                          name={'searchRole'}
                          defaultValue={searchRole}
                          onChange={(e)=>{
                              setSearchRole(e.target.value);
                          }}
                          list={roleTypes}
                      />
                    </FormControl>

                    <FormControl sx={{ m: 1, minWidth: 120 }}>
                      <CustomEnumSelect
                          key={searchField}
                          label={t('message.common.btn.search')}
                          labelName={t('message.common.btn.search')}
                          name={'searchField'}
                          defaultValue={searchField}
                          onChange={(e)=>{
                              setSearchField(e.target.value);
                          }}
                          isLabelView={false}
                          list={searchFields}
                      />
                    </FormControl>
                    
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword || ''} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>

                    <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                    </>
                    }
                  </div>
                </div>
                {/* <div className="btn_right">
                  <Link to={'./add?searchRole='+searchRole+'&searchField='+searchField+'&searchKeyword='+searchKeyword+'&page='+currentPage}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
                </div> */}
              </div>
            </Box>
          </div>
            {/*  */}
        </div>
      </div>

      <Box 
        id="tableDiv"
        sx={{
          mt: 3,
          padding: "20px",
          borderRadius: "20px",
          overflow: "hidden",
          background: `${mode === 'dark' ? "#182131": "#fff"}`,
          border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        }}
      >
        <DataGridPro
          rows={users && users !== undefined ? users : []}
          columns={columns}
          disableColumnFilter
          sortModel={sortModel || []}
          onSortModelChange={setSortModel}
          localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
              display: "none",
            },
            "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
          }}
        />
      
        <div className="btn_right">
          <Link to={'./add?searchRole='+searchRole+'&searchField='+searchField+'&searchKeyword='+searchKeyword+'&page='+currentPage}><Button variant="contained" color="primary">{t('message.common.btn.write')}</Button></Link>
        </div>

        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
      </Box>
    </div>
  );
}
 
export default UserSetting;